/**
 * Replaces the path without causing a re-render.
 *
 * @example
 * replacePath("/onboarding/1"); // localhost:xxxx/onboarding/1
 */
export const replacePath = (path: string) => {
  window.history.replaceState(null, "", `${path}`);
};
